export enum RequestTypes {
  Save = "Save",
  Deletion = "Deletion",
  Fetch = "Fetch",
  CustomProcess = "CustomProcess",
  GenerateDocument = "GenerateDocument",
}

export enum StringHorizontalAlignment {
  Left = 1,
  Center = 2,
  Right = 3,
  Justified = 4,
}

export enum EMailSSLConnectionOptions {
  None = 0,
  Auto = 1,
  SslOnConnect = 2,
  StartTls = 3,
  StartTlsWhenAvailable = 4,
}

export enum PlatformTypes {
  Desktop = 1,
  Mobile = 2,
}

export enum DeviceOrientations {
  Portrait = 1,
  Landscape = 2,
}

export enum Roles {
  None = 0,
  SuperAdmin = 100,
  DHO = 200,
  DCM = 300,
  THO = 400,
  BCM = 500,
  AF = 600,
  Asha = 700,
  MO = 800,
  Developer = 900,
}

export enum SeparationType {
  None = 0,
  Resignation = 100,
  Termination = 200,
}

export enum ApprovalList {
  None = 0,
  IsAshaTrainingTrsApproved = 1,
  IsHRTrsApproved = 2,
  IsAshaTrainingTrsSummaryApproved = 3,
  IsAFTrainingTrsSummaryApproved = 4,
  IsAFCentralIncentiveTrsApproved = 5,
  IsAFStateIncentiveApproved = 6,
  IsAshaPerformanceTrsApproved = 7,
  IsHBNCTransactionApproved = 8,
  IsAFHBNCTrsApproved = 9,
  IsHBYCTrainedTrsApproved = 10,
  IsHBYCUntrainedTrsApproved = 11,
  IsMotherMeetingTrsApproved = 12,
  IsIodineTrsApproved = 13,
  IsGrievanceTrsApproved = 14,
  IsEmployeeStateIncentiveApproved = 15,
  IsDevelopmentalDelayChildrenTrsApproved = 16,
  IsDefectiveChildrenTrsApproved = 17,
  IsRBSKTrsApproved = 18,
  IsBirthSpacingTrsApproved = 19,
  IsContraceptivePillStockTrsApproved = 20,
  IsHBNCKitTrsApproved = 21,
  IsSanitaryNapkinStockTrsApproved = 22,
}
export enum MenuIdEnum {
  None = 'None',

  // Dashboard
  Dashboard = 'Dashboard',

  // Masters
  State = 'State',
  Zone = 'Zone',
  District = 'District',
  Block = 'Block',
  PHC = 'PHC',
  SC = 'SC',
  Village = 'Village',

  // RBSK
  Birth_Defect_Type = 'Birth_Defect_Type',

  // Sanctioned Posts
  DCM_Post = 'DCM_Post',
  BCM_Post = 'BCM_Post',
  AF_Post = 'AF_Post',
  Asha_Post = 'Asha_Post',

  // Training
  Training_Group = 'Training_Group',
  Training_Type = 'Training_Type',

  // Performance
  Performance_Group = 'Performance_Group',
  Performance_Type_Master = 'Performance_Type_Master',
  Performance_Activity_Rate = 'Performance_Activity_Rate',

  // HBNC
  HBNC_Group = 'HBNC_Group',
  HBNC_Type = 'HBNC_Type',
  HBNC_Kit = 'HBNC_Kit',

  // HBYC
  HBYC_Group = 'HBYC_Group',
  HBYC_Type = 'HBYC_Type',
  HBYC_Untrained_Group = 'HBYC_Untrained_Group',
  HBYC_Untrained_Type = 'HBYC_Untrained_Type',

  // MAA Meeting
  Mother_Meeting_Group = 'Mother_Meeting_Group',
  Mother_Meeting_Type = 'Mother_Meeting_Type',

  // Spacing of Birth
  Spacing_of_Birth_Group = 'Spacing_of_Birth_Group',
  Spacing_of_Birth_Type = 'Spacing_of_Birth_Type',

  // Other Masters
  Category = 'Category',
  Vima_Yojana = 'Vima_Yojana',
  Relation = 'Relation',
  Roles = 'Roles',
  DHO = 'DHO',
  THO = 'THO',
  DCM = 'DCM',
  BCM = 'BCM',
  MO = 'MO',
  AF = 'AF',
  Asha = 'Asha',
  AF_Central_Incentive = 'AF_Central_Incentive',
  AF_State_Incentive = 'AF_State_Incentive',
  Promotion = 'Promotion',
  Termination = 'Termination',
  Resignation = 'Resignation',
  Sanitary_Napkin_Rate = 'Sanitary_Napkin_Rate',
  Employee_Visit_Type = 'Employee_Visit_Type',
  Report_Submission_Configuration = 'Report_Submission_Configuration',

  // Transactions
  Asha_Training = 'Asha_Training',
  Asha_Hr = 'Asha_Hr',
  Asha_Training_Report = 'Asha_Training_Report',
  AF_Training_Report = 'AF_Training_Report',
  Edit_Request = 'Edit_Request',
  Edit_Request_Approval = 'Edit_Request_Approval',
  State_Incentive = 'State_Incentive',
  Asha_Performance = 'Asha_Performance',
  Monthly_HBNC = 'Monthly_HBNC',
  Monthly_HBYC = 'Monthly_HBYC',
  AF_HBNC = 'AF_HBNC',
  Monthly_HBYC_Untrained = 'Monthly_HBYC_Untrained',
  MAA_Meeting = 'MAA_Meeting',
  Iodine_Testing = 'Iodine_Testing',
  Grievance_Monitoring = 'Grievance_Monitoring',
  Employee_State_Incentive = 'Employee_State_Incentive',
  Developmental_Delay_Children = 'Developmental_Delay_Children',
  Defective_Children = 'Defective_Children',
  RBSK_Transaction = 'RBSK_Transaction',
  Spacing_of_Birth = 'Spacing_of_Birth',
  Contraceptive_Pills_Opening_Stock = 'Contraceptive_Pills_Opening_Stock',
  Contraceptive_Pill = 'Contraceptive_Pill',
  HBNC_Kit_Transaction = 'HBNC_Kit_Transaction',
  Sanitary_Napkin_Opening = 'Sanitary_Napkin_Opening',
  Sanitary_Napkin_Distribution = 'Sanitary_Napkin_Distribution',
  Employee_Visit_Transaction = 'Employee_Visit_Transaction',

  Anemia_Mukta_Bharat_Opening_Stock = 'Anemia_Mukta_Bharat_Opening_Stock',
  Anemia_Mukta_Bharat = 'Anemia_Mukta_Bharat',

  // Reports
  AF_Profile_Data_Report = 'AF_Profile_Data_Report',
  Asha_Profile_Data = 'Asha_Profile_Data',
  Asha_Training_Information_Report = 'Asha_Training_Information_Report',
  AF_Training_Information_Report = 'AF_Training_Information_Report',
  Asha_Training_Summary_Report = 'Asha_Training_Summary_Report',
  AF_Training_Summary_Report = 'AF_Training_Summary_Report',
  Asha_Performance_Report = 'Asha_Performance_Report',
  Central_Incentive_Report = 'Central_Incentive_Report',
  State_Incentive_Report = 'State_Incentive_Report',
  Asha_Incentive_Report = 'Asha_Incentive_Report',
  Monthly_Asha_Incentive_Report = 'Monthly_Asha_Incentive_Report',
  AF_Wise_Incentive_Report = 'AF_Wise_Incentive_Report',
  Monthly_HBNC_Report = 'Monthly_HBNC_Report',
  Monthly_HBYC_Report = 'Monthly_HBYC_Report',
  Monthly_HBYC_Untrained_Report = 'Monthly_HBYC_Untrained_Report',
  MAA_Meeting_Report = 'MAA_Meeting_Report',
  Grievance_Mentoring_Report = 'Grievance_Mentoring_Report',
  AF_Rajyashasan_Mandhan_Report = 'AF_Rajyashasan_Mandhan_Report',
  Asha_Rajyashasan_Mandhan_Report = 'Asha_Rajyashasan_Mandhan_Report',
  Asha_AF_Policy_Report = 'Asha_AF_Policy_Report',
  Defective_Children_Report = 'Defective_Children_Report',
  Developmental_Delay_Children_Report = 'Developmental_Delay_Children_Report',
  Iodine_Testing_Report = 'Iodine_Testing_Report',
  Cumulitive_RBSK_Report = 'Cumulitive_RBSK_Report',
  RBSK_Report = 'RBSK_Report',
  Spacing_Of_Birth_Report = 'Spacing_Of_Birth_Report',
  HR_Report = 'HR_Report',
  Contraceptive_Pill_Report = 'Contraceptive_Pill_Report',
  HBNC_Kit_Report = 'HBNC_Kit_Report',
  Sanitary_Napkin_Report = 'Sanitary_Napkin_Report',
  BCMEmployee_Visit_Record_Report = 'BCMEmployee_Visit_Record_Report',
  AFEmployee_Visit_Record_Report = 'AFEmployee_Visit_Record_Report'
}


export enum Month {
  None = 0,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
  January = 1,
  February = 2,
  March = 3,
}

export enum MaritalStatuses {
  None = 0,
  UnMarried = 10,
  Married = 20,
  Divorced = 30,
  LiveInRelationship = 40,
  Widow = 50,
  Widower = 60,
  // Separated = 40,
}

export enum ActivityFrequencyTypes {
  None = 0,
  Monthly = 100,
  Yearly = 200,
}

export enum ActivityTypes {
  None = 0,
  RoutineActivity = 100,
  HWC = 200,
  StateGovernmentAllowance = 300,
  HBNC = 400,
  NationalDewormingDay = 500,
}

export enum ReportFilterTypes {
  None = 0,
  Monthly = 100,
  Quarterly = 200,
  HalfYearly = 300,
  Yearly = 400,
  Custom = 500,
}
export enum IncentiveRoles {
  None = 0,
  AF = 100,
  Asha = 200,
  // AshaAndAF = 300,
}

export enum Quarter {
  None = 0,
  First_Quarter = 100,
  Second_Quarter = 200,
  Third_Quarter = 300,
  Fourth_Quarter = 400,
}

export enum HalfYear {
  None = 0,
  First_Half = 100,
  Second_Half = 200,
}

export enum SystemDefinedTrainingType {
  None = 0,
  InductionTraining = 100,
  HBNC4thModule = 200,
  HBNC6thModule = 300,
  HBNC7thModule = 400,
  HBYC = 500,
}

export enum Honorifics {
  None = 0,
  Mr = 100,
  Mrs = 200,
  Ms = 300,
  Miss = 400,
  Dr = 500,
  Prof = 600,
}

export enum ReportModes {
  None = 0,
  Detail = 100,
  Cumulative = 200,
}

export enum CumulativeReportLimits {
  None = 0,
  UPTOBlock = 100,
  UPTOPHC = 200,
  UPTOAF = 300,
}

export enum SystemDefinedBirthDefectTypes {
  None = 0,
  NeuralTubeDefect = 100,
  DownSyndrome = 200,
  CleftLipOrPalate = 300,
  ClubFoot = 400,
  DevelopmentalHipDysplasia = 500,
  OtherDefects = 2000,
}

export enum BirthAgeTypes {
  None = 0,
  UptoThreeMonth = 100,
  UptoSixMonth = 200,
  UptoNineMonth = 300,
  UptoTwelveMonth = 400,
  UptoFifteenMonth = 500,
}

export enum Genders {
  None = 0,
  Male = 10,
  Female = 20,
  Transgender = 30,
}

export enum DropdownLimits {
  None = 0,
  UPToZone = 100,
  UPTODistrict = 200,
  UPTOBlock = 300,
  UPTOPHC = 400,
  UPTOAF = 500,
  UPTOSC = 600,
  UPTOVillage = 700,
  UPTOAsha = 800,
  UPTOBCMPost = 900,
  UPTOAFPost = 1000,
  UPTOState = 1100,
}
export enum DashboardDropdownHierarchyLevels {
  None = 0,
  State = 100,
  Zone = 200,
  District = 300,
  Block = 400,
  BCM = 500,
  PHC = 600,
  AF = 700,
  SC = 800,
  Village = 900,
  Asha = 1000,
}

export enum HierarchyLevelsForTransaction {
  None = 0,
  UPToAsha = 10,
  UPToAF = 20,
  UPTOBCM = 30,
  UPTOAFWithVillage = 40,
  UPTOBCMWithVillage = 50,
  UPTOPHC = 60,
}

export enum HierarchyLevelsForReport {
  None = 0,
  UPToAshaForFilter = 10,
  UPToAFForFilter = 20,
  UPTOBCMForFilter = 30,
  UPTOAFWithVillageForFilter = 40,
  UPTOBCMWithVillageForFilter = 50,
}

// Contraceptive Pills
export enum ContraceptivePillsTypes {
  None = 0,
  Condom = 100,
  Mala_N = 200,
  ECPills = 300,
  Chhaya = 400,
  Antara = 500,
  PPIUCD = 600,
  PAIUCD = 700
}

// Contraceptive Pills BI-Lingual
// export enum ContraceptivePillsTypeslang {
//   None = 0,
//   Condom = 100,
//   Mala_N = 200,
//   ECPills = 300,
//   Chhaya = 400,
//   Antara = 500,
//   PPIUCD = 600
// }

// Sterilisation Type BI-Lingual
export enum SterilisationTypeslang {
  None = 0,
  TubalLigation = 100,
  Vasectomy = 200,
}

export enum RequestStatuses {
  None = 0,
  Pending = 100,
  // Approved = 200,
  // Rejected = 300,
  Cancelled = 400,
}
export enum UPTTestResultType{
  None = 0,
  Positive = 100,
  Negative = 200,
}


export enum StillBirthTypes {
  None = 0,
  Fresh = 100,
  Macerated = 200,
}

export enum ApprovalStatuses {
  None = 0,
  // Pending = 100,
  Approved = 200,
  Rejected = 300,
  // Cancelled = 400,
}

export enum TransactionTypes {
  // AshaTrainingTrs = 100,
  // HRTrs = 200,
  // AshaTrainingTrsSummary = 300,
  // AFTrainingTrsSummary = 400,
  // AFCentralIncentiveTrs = 500,
  // AFStateIncentive = 600,
  // AshaPerformanceTrs = 700,
  // HBNCTransaction = 800,
  // AFHBNCTrs = 900,
  // HBYCTrainedTrs = 1000,
  // HBYCUntrainedTrs = 1100,
  // MotherMeetingTrs = 1200,
  // IodineTrs = 1300,
  // GrievanceTrs = 1400,
  // EmployeeStateIncentive = 1500,
  // DevelopmentalDelayChildrenTrs = 1600,
  // DefectiveChildrenTrs = 1700,
  // RBSKTrs = 1800,
  // BirthSpacingTrs = 1900,
  // ContraceptivePillStockTrs = 2000,
  // HBNCKitTrs = 2100,
  // SanitaryNapkinStockTrs = 2200,
  EditRequestForm = 2300,
  // VisitForm = 2400,
  // AnemiaMuktaBharatOpeningStockTrs = 1600,
  // AnemiaMuktaBharatTrs = 1600,
  // FamilyRegistration = 2500,
  FamilyRegistration = 100,
  EditRequestApprovalForm = 2400,
  // add others
}

export enum OperationalModes {
  CanAdd = 100,
  CanEdit = 200,
  CanView = 300,
}

export enum AppTypes {
  Mobile = 10,
  Web = 20,
}

// Anemia Mukta Bharat Opening Stock Pills
export enum AnemiaMuktaBharatTypes {
  None = 0,
  IFA_Tablet_Red = 100,
  IFA_Syrup = 200,
}

// Dashboard Asha incentive 
export enum IncentiveTypes {
  ZeroIncentive = 100,
  IncentiveBelow13000 = 200,
  Incentive13001To15000 = 300,
  Incentive15001To20000 = 400,
  IncentiveAbove20000 = 500,
  IncentiveBelow15000 = 600,
  IncentiveAbove15000 = 700,
  IncentiveAnalysis = 800, // Exclude Rajyashasan Mandhan
  TopFiveIncentive = 900,
  // ZeroPerformance  = 1000,
}

export enum StateIncentiveTypes {
  None = 0,
  Sanction = 100,
  Given = 200,
  Remaining = 300,
}

// Family Registration 
export enum EconomicStatuses {
  None = 0,
  BPL = 100,
  APL = 200,
  WhiteCard = 300,
}
export enum FamilyTypes {
  None = 0,
  Nuclear = 100,
  Joint = 200,
}

export enum MigrationStatuses {
  None = 0,
  Seasonal = 100,
  Permanent = 200,
  Temporary = 300,
}

export enum BloodGroups {
  None = 0,
  APositive = 100,
  ANegative = 200,
  BPositive = 300,
  BNegative = 400,
  ABPositive = 500,
  ABNegative = 600,
  OPositive = 700,
  ONegative = 800,
}

export enum Occupations {
  None = 0,
  Employed = 100,
  Unemployed = 200,
  Student = 300,
  Farmer = 400,
  Business = 500,
  SelfEmployed = 600,
  HomeMaker = 700,
  Retired = 800,
  NA = 900,
  Labour = 1000,
}

export enum Educations {
  None = 0,
  Uneducated = 100,
  Below8th = 200,
  Eighth = 300,
  Tenth = 400,
  JuniorCollege = 500,
  Graduation = 600,
  PostGraduation = 700,
  Phd = 800,
  NA = 900
}

export enum Languages {
  None = 0,
  English = 100,
  Marathi = 200
}

export enum ResidencyStatuses {
  None = 0,
  Native = 100,
  Migrated = 200,
}

export enum ApprovalStatusesForFamilyRegistration {
  None = 0,
  Pending = 100,
  Approved = 200,
  Rejected = 300,
  Cancelled = 400,
  ReturnForCorrection = 500,
  CorrectionDone = 600
}

export enum HospitalTypes {
  None = 0,
  Private = 100,
  Government = 200,
}

export enum DeliveryTypes {
  None = 0,
  Normal = 100,
  CSection = 200,
  AssistedVaginal = 300,
  Preterm = 400,
  NotApplicable = 2000,
}

export enum PregnancyOutcomeTypes {
  None = 0,
  LiveBirth = 100,
  StillBirth = 200,
  AbortionInduced = 300,
  Miscarriage = 400,
}

export enum OutcomePlaceTypes {
  None = 0,
  Home = 100,
  Hospital = 200,
}

export enum DeathTypes {
  None = 0,
  Natural = 100,
  Accidental = 200,
  Suicide = 300,
  Homicide = 400,
  Sick = 500,
}

export class DomainEnums {
  public static DropdownLimitsName(itemType: DropdownLimits) {
    switch (itemType) {
      case DropdownLimits.UPToZone:
        return "UPTO Zone";
      case DropdownLimits.UPTODistrict:
        return "UPTO District";
      case DropdownLimits.UPTOBlock:
        return "UPTO Block";
      case DropdownLimits.UPTOPHC:
        return "UPTO PHC";
      case DropdownLimits.UPTOAF:
        return "UPTO AF";
      case DropdownLimits.UPTOSC:
        return "UPTO SC";
      case DropdownLimits.UPTOAsha:
        return "UPTO Asha";
      default:
        return "";
    }
  }

  public static DropdownLimitsList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: DropdownLimits.UPToZone,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPToZone),
      },
      {
        Ref: DropdownLimits.UPTODistrict,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPTODistrict),
      },
      {
        Ref: DropdownLimits.UPTOBlock,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPTOBlock),
      },
      {
        Ref: DropdownLimits.UPTOPHC,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPTOPHC),
      },
      {
        Ref: DropdownLimits.UPTOAF,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPTOAF),
      },
      {
        Ref: DropdownLimits.UPTOSC,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPTOSC),
      },
      {
        Ref: DropdownLimits.UPTOVillage,
        Name: DomainEnums.DropdownLimitsName(DropdownLimits.UPTOVillage),
      },
    ];
    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }
    return result;
  }

  public static SystemDefinedBirthDefectTypesName(
    itemType: SystemDefinedBirthDefectTypes,
  ) {
    switch (itemType) {
      case SystemDefinedBirthDefectTypes.NeuralTubeDefect:
        return "मज्जासंस्थेतील विकृती (न्यूरल ट्यूब डिफेक्ट)";
      case SystemDefinedBirthDefectTypes.DownSyndrome:
        return "डाऊन्स सिंड्रोम (Down’s Syndrome)  ";
      case SystemDefinedBirthDefectTypes.CleftLipOrPalate:
        return "दुभंगलेले टाळू व ओठ";
      case SystemDefinedBirthDefectTypes.ClubFoot:
        return "क्लब फूट (वाकडे पाय)";
      case SystemDefinedBirthDefectTypes.DevelopmentalHipDysplasia:
        return "कमरेच्या हाडामधील विकृती (कमरेचे हाड योग्य जागी नसणे)";
      case SystemDefinedBirthDefectTypes.OtherDefects:
        return "Other Defects ";
      default:
        return "";
    }
  }

  public static SystemDefinedBirthDefectTypesList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: SystemDefinedBirthDefectTypes.NeuralTubeDefect,
        Name: DomainEnums.SystemDefinedBirthDefectTypesName(
          SystemDefinedBirthDefectTypes.NeuralTubeDefect,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.DownSyndrome,
        Name: DomainEnums.SystemDefinedBirthDefectTypesName(
          SystemDefinedBirthDefectTypes.DownSyndrome,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.CleftLipOrPalate,
        Name: DomainEnums.SystemDefinedBirthDefectTypesName(
          SystemDefinedBirthDefectTypes.CleftLipOrPalate,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.ClubFoot,
        Name: DomainEnums.SystemDefinedBirthDefectTypesName(
          SystemDefinedBirthDefectTypes.ClubFoot,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.DevelopmentalHipDysplasia,
        Name: DomainEnums.SystemDefinedBirthDefectTypesName(
          SystemDefinedBirthDefectTypes.DevelopmentalHipDysplasia,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.OtherDefects,
        Name: DomainEnums.SystemDefinedBirthDefectTypesName(
          SystemDefinedBirthDefectTypes.OtherDefects,
        ),
      },
    ];
      if (withAllOption) {
      let allEntry = {
        Ref: SystemDefinedBirthDefectTypes.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }



      public static SystemDefinedBirthDefectTypesNameLang(
    itemType: SystemDefinedBirthDefectTypes,
  ) {
    switch (itemType) {
      case SystemDefinedBirthDefectTypes.NeuralTubeDefect:
        return "ENUMS.SYSTEM_DEFINED_BIRTH_DEFECT_TYPES_NAME.NeuralTubeDefect";
      case SystemDefinedBirthDefectTypes.DownSyndrome:
        return "ENUMS.SYSTEM_DEFINED_BIRTH_DEFECT_TYPES_NAME.DownSyndrome";
      case SystemDefinedBirthDefectTypes.CleftLipOrPalate:
        return "ENUMS.SYSTEM_DEFINED_BIRTH_DEFECT_TYPES_NAME.CleftLipOrPalate";
      case SystemDefinedBirthDefectTypes.ClubFoot:
        return "ENUMS.SYSTEM_DEFINED_BIRTH_DEFECT_TYPES_NAME.ClubFoot";
      case SystemDefinedBirthDefectTypes.DevelopmentalHipDysplasia:
        return "ENUMS.SYSTEM_DEFINED_BIRTH_DEFECT_TYPES_NAME.DevelopmentalHipDysplasia";
      case SystemDefinedBirthDefectTypes.OtherDefects:
        return "ENUMS.SYSTEM_DEFINED_BIRTH_DEFECT_TYPES_NAME.OtherDefects";
      default:
        return "";
    }
  }

  public static SystemDefinedBirthDefectTypesListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: SystemDefinedBirthDefectTypes.NeuralTubeDefect,
        Name: DomainEnums.SystemDefinedBirthDefectTypesNameLang(
          SystemDefinedBirthDefectTypes.NeuralTubeDefect,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.DownSyndrome,
        Name: DomainEnums.SystemDefinedBirthDefectTypesNameLang(
          SystemDefinedBirthDefectTypes.DownSyndrome,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.CleftLipOrPalate,
        Name: DomainEnums.SystemDefinedBirthDefectTypesNameLang(
          SystemDefinedBirthDefectTypes.CleftLipOrPalate,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.ClubFoot,
        Name: DomainEnums.SystemDefinedBirthDefectTypesNameLang(
          SystemDefinedBirthDefectTypes.ClubFoot,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.DevelopmentalHipDysplasia,
        Name: DomainEnums.SystemDefinedBirthDefectTypesNameLang(
          SystemDefinedBirthDefectTypes.DevelopmentalHipDysplasia,
        ),
      },
      {
        Ref: SystemDefinedBirthDefectTypes.OtherDefects,
        Name: DomainEnums.SystemDefinedBirthDefectTypesNameLang(
          SystemDefinedBirthDefectTypes.OtherDefects,
        ),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: SystemDefinedBirthDefectTypes.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static EMailSSLConnectionOptionName(value: EMailSSLConnectionOptions) {
    switch (value) {
      case EMailSSLConnectionOptions.None:
        return "None";
      case EMailSSLConnectionOptions.Auto:
        return "Auto";
      case EMailSSLConnectionOptions.SslOnConnect:
        return "SSLOnConnect";
      case EMailSSLConnectionOptions.StartTls:
        return "StartTLS";
      case EMailSSLConnectionOptions.StartTlsWhenAvailable:
        return "StartTLSWhenAvailable";
      default:
        return "";
    }
  }

  public static EMailSSLConnectionOptionList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: EMailSSLConnectionOptions.None,
        Name: DomainEnums.EMailSSLConnectionOptionName(
          EMailSSLConnectionOptions.None,
        ),
      },
      {
        Ref: EMailSSLConnectionOptions.Auto,
        Name: DomainEnums.EMailSSLConnectionOptionName(
          EMailSSLConnectionOptions.Auto,
        ),
      },
      {
        Ref: EMailSSLConnectionOptions.SslOnConnect,
        Name: DomainEnums.EMailSSLConnectionOptionName(
          EMailSSLConnectionOptions.SslOnConnect,
        ),
      },
      {
        Ref: EMailSSLConnectionOptions.StartTls,
        Name: DomainEnums.EMailSSLConnectionOptionName(
          EMailSSLConnectionOptions.StartTls,
        ),
      },
      {
        Ref: EMailSSLConnectionOptions.StartTlsWhenAvailable,
        Name: DomainEnums.EMailSSLConnectionOptionName(
          EMailSSLConnectionOptions.StartTlsWhenAvailable,
        ),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static RolesName(item: Roles) {
    switch (item) {
      case Roles.SuperAdmin:
        return "Super Admin";
      case Roles.DHO:
        return "District Health Officer";
      case Roles.DCM:
        return "District Community Mobilizer";
      case Roles.THO:
        return "Taluka Health Officer";
      case Roles.BCM:
        return "Block Community Mobilizer";
      case Roles.MO:
        return "Medical Officer";
      case Roles.AF:
        return "Asha Facilitators";
      case Roles.Asha:
        return "Asha";
      case Roles.Developer:
        return "Developer";
      default:
        return "";
    }
  }

  public static RolesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: Roles.None,
        Name: DomainEnums.RolesName(Roles.None),
      },
      {
        Ref: Roles.SuperAdmin,
        Name: DomainEnums.RolesName(Roles.SuperAdmin),
      },
      {
        Ref: Roles.DHO,
        Name: DomainEnums.RolesName(Roles.DHO),
      },
      {
        Ref: Roles.DCM,
        Name: DomainEnums.RolesName(Roles.DCM),
      },
      {
        Ref: Roles.THO,
        Name: DomainEnums.RolesName(Roles.THO),
      },
      {
        Ref: Roles.BCM,
        Name: DomainEnums.RolesName(Roles.BCM),
      },
      {
        Ref: Roles.MO,
        Name: DomainEnums.RolesName(Roles.MO),
      },
      {
        Ref: Roles.AF,
        Name: DomainEnums.RolesName(Roles.AF),
      },
      {
        Ref: Roles.Asha,
        Name: DomainEnums.RolesName(Roles.Asha),
      },
      {
        Ref: Roles.Developer,
        Name: DomainEnums.RolesName(Roles.Developer),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static SeparationTypeName(item: SeparationType) {
    switch (item) {
      case SeparationType.Resignation:
        return "Resignation";
      case SeparationType.Termination:
        return "Termination";
      default:
        return "";
    }
  }

  public static SeparationTypeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: SeparationType.None,
        Name: DomainEnums.SeparationTypeName(SeparationType.None),
      },
      {
        Ref: SeparationType.Resignation,
        Name: DomainEnums.SeparationTypeName(SeparationType.Resignation),
      },
      {
        Ref: SeparationType.Termination,
        Name: DomainEnums.SeparationTypeName(SeparationType.Termination),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static MonthName(itemType: Month) {
    switch (itemType) {
      case Month.January:
        return "January";
      case Month.February:
        return "February";
      case Month.March:
        return "March";
      case Month.April:
        return "April";
      case Month.May:
        return "May";
      case Month.June:
        return "June";
      case Month.July:
        return "July";
      case Month.August:
        return "August";
      case Month.September:
        return "September";
      case Month.October:
        return "October";
      case Month.November:
        return "November";
      case Month.December:
        return "December";
      default:
        return "";
    }
  }

  public static MonthList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
    year: number = new Date().getFullYear(),
  ) {
    const getDaysInMonth = (month: Month, year: number): number => {
      if (month === Month.None) return 0;
      return new Date(year, month, 0).getDate(); // Date(year, monthIndex + 1, 0) returns last day of the month
    };

    let result = Object.values(Month)
      .filter((value) => typeof value === "number" && value !== Month.None)
      .map((month: Month) => ({
        Ref: month,
        Name: DomainEnums.MonthName(month),
        Days: getDaysInMonth(month, year),
      }));

    if (withAllOption) {
      let allEntry = {
        Ref: Month.None,
        Name: allOptionName,
        Days: 0,
      };
      result.unshift(allEntry);
    }

    return result;
  }


  public static MonthNames(itemType: Month) {
    switch (itemType) {
      case Month.January:
        return "ENUMS.MONTHS.January";
      case Month.February:
        return "ENUMS.MONTHS.February";
      case Month.March:
        return "ENUMS.MONTHS.March";
      case Month.April:
        return "ENUMS.MONTHS.April";
      case Month.May:
        return "ENUMS.MONTHS.May";
      case Month.June:
        return "ENUMS.MONTHS.June";
      case Month.July:
        return "ENUMS.MONTHS.July";
      case Month.August:
        return "ENUMS.MONTHS.August";
      case Month.September:
        return "ENUMS.MONTHS.September";
      case Month.October:
        return "ENUMS.MONTHS.October";
      case Month.November:
        return "ENUMS.MONTHS.November";
      case Month.December:
        return "ENUMS.MONTHS.December";
      default:
        return "";
    }
  }

  public static MonthListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
    year: number = new Date().getFullYear(),
  ) {
    const getDaysInMonth = (month: Month, year: number): number => {
      if (month === Month.None) return 0;
      return new Date(year, month, 0).getDate(); // Date(year, monthIndex + 1, 0) returns last day of the month
    };

    let result = Object.values(Month)
      .filter((value) => typeof value === "number" && value !== Month.None)
      .map((month: Month) => ({
        Ref: month,
        Name: DomainEnums.MonthNames(month),
        Days: getDaysInMonth(month, year),
      }));

    if (withAllOption) {
      let allEntry = {
        Ref: Month.None,
        Name: allOptionName,
        Days: 0,
      };
      result.unshift(allEntry);
    }

    return result;
  }


  public static ApprovalListName(itemType: ApprovalList) {
    switch (itemType) {
      case ApprovalList.IsAshaTrainingTrsApproved:
        return "Asha Training Information";
      case ApprovalList.IsHRTrsApproved:
        return "Asha HR";
      case ApprovalList.IsAshaTrainingTrsSummaryApproved:
        return "Asha Traning Report";
      case ApprovalList.IsAFTrainingTrsSummaryApproved:
        return "AF Traning Report";
      case ApprovalList.IsAFCentralIncentiveTrsApproved:
        return "Central Incentive";
      case ApprovalList.IsAFStateIncentiveApproved:
        return "State Incentive";
      case ApprovalList.IsAshaPerformanceTrsApproved:
        return "Asha Performance";
      case ApprovalList.IsHBNCTransactionApproved:
        return "Monthly HBNC";
      case ApprovalList.IsAFHBNCTrsApproved:
        return "Monthly AF HBNC";
      case ApprovalList.IsHBYCTrainedTrsApproved:
        return "Monthly HBYC";
      case ApprovalList.IsHBYCUntrainedTrsApproved:
        return "Monthly HBYC Untrained";
      case ApprovalList.IsMotherMeetingTrsApproved:
        return "Monthly Meeting of Mother";
      case ApprovalList.IsIodineTrsApproved:
        return "Iodine Testing";
      case ApprovalList.IsGrievanceTrsApproved:
        return "Grievance Mentoring";
      case ApprovalList.IsEmployeeStateIncentiveApproved:
        return "Employee State Incentive";
      case ApprovalList.IsDevelopmentalDelayChildrenTrsApproved:
        return "Developmental Delay Children";
      case ApprovalList.IsDefectiveChildrenTrsApproved:
        return "Defective Children";
      case ApprovalList.IsRBSKTrsApproved:
        return "RBSK";
      case ApprovalList.IsBirthSpacingTrsApproved:
        return "Birth Spacing";
      case ApprovalList.IsContraceptivePillStockTrsApproved:
        return "Contraceptive Pill Stock";
      case ApprovalList.IsHBNCKitTrsApproved:
        return "HBNC Kit";
      case ApprovalList.IsSanitaryNapkinStockTrsApproved:
        return "Sanitary Napkin Stock";
      default:
        return "";
    }
  }

  public static ApprovalList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: ApprovalList.IsAshaTrainingTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsAshaTrainingTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsHRTrsApproved,
        Name: DomainEnums.ApprovalListName(ApprovalList.IsHRTrsApproved),
        Value: false,
      },
      {
        Ref: ApprovalList.IsAshaTrainingTrsSummaryApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsAshaTrainingTrsSummaryApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsAFTrainingTrsSummaryApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsAFTrainingTrsSummaryApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsAFCentralIncentiveTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsAFCentralIncentiveTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsAFStateIncentiveApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsAFStateIncentiveApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsAshaPerformanceTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsAshaPerformanceTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsHBNCTransactionApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsHBNCTransactionApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsAFHBNCTrsApproved,
        Name: DomainEnums.ApprovalListName(ApprovalList.IsAFHBNCTrsApproved),
        Value: false,
      },
      {
        Ref: ApprovalList.IsHBYCTrainedTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsHBYCTrainedTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsHBYCUntrainedTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsHBYCUntrainedTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsMotherMeetingTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsMotherMeetingTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsIodineTrsApproved,
        Name: DomainEnums.ApprovalListName(ApprovalList.IsIodineTrsApproved),
        Value: false,
      },
      {
        Ref: ApprovalList.IsGrievanceTrsApproved,
        Name: DomainEnums.ApprovalListName(ApprovalList.IsGrievanceTrsApproved),
        Value: false,
      },
      {
        Ref: ApprovalList.IsEmployeeStateIncentiveApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsEmployeeStateIncentiveApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsDevelopmentalDelayChildrenTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsDevelopmentalDelayChildrenTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsDefectiveChildrenTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsDefectiveChildrenTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsRBSKTrsApproved,
        Name: DomainEnums.ApprovalListName(ApprovalList.IsRBSKTrsApproved),
        Value: false,
      },
      {
        Ref: ApprovalList.IsBirthSpacingTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsBirthSpacingTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsContraceptivePillStockTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsContraceptivePillStockTrsApproved,
        ),
        Value: false,
      },
      {
        Ref: ApprovalList.IsHBNCKitTrsApproved,
        Name: DomainEnums.ApprovalListName(ApprovalList.IsHBNCKitTrsApproved),
        Value: false,
      },
      {
        Ref: ApprovalList.IsSanitaryNapkinStockTrsApproved,
        Name: DomainEnums.ApprovalListName(
          ApprovalList.IsSanitaryNapkinStockTrsApproved,
        ),
        Value: false,
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: ApprovalList.None,
        Name: allOptionName,
        Value: false,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static MaritalStatusesName(itemType: MaritalStatuses) {
    switch (itemType) {
      case MaritalStatuses.UnMarried:
        return "Un-Married ";
      case MaritalStatuses.Married:
        return "Married";
      case MaritalStatuses.Divorced:
        return "Divorced ";
      case MaritalStatuses.LiveInRelationship:
        return "Live-In Relationship ";
      // case MaritalStatuses.Separated:
      //   return "Separated ";
      case MaritalStatuses.Widow:
        return "Widow ";
      case MaritalStatuses.Widower:
        return "Widower ";
      default:
        return "";
    }
  }

  public static MaritalStatusesList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: MaritalStatuses.UnMarried,
        Name: DomainEnums.MaritalStatusesName(MaritalStatuses.UnMarried),
      },
      {
        Ref: MaritalStatuses.Married,
        Name: DomainEnums.MaritalStatusesName(MaritalStatuses.Married),
      },
      {
        Ref: MaritalStatuses.Divorced,
        Name: DomainEnums.MaritalStatusesName(MaritalStatuses.Divorced),
      },
      {
        Ref: MaritalStatuses.LiveInRelationship,
        Name: DomainEnums.MaritalStatusesName(MaritalStatuses.LiveInRelationship),
      },
      // {
      //   Ref: MaritalStatuses.Separated,
      //   Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.Separated),
      // },
      {
        Ref: MaritalStatuses.Widow,
        Name: DomainEnums.MaritalStatusesName(MaritalStatuses.Widow),
      },
      {
        Ref: MaritalStatuses.Widower,
        Name: DomainEnums.MaritalStatusesName(MaritalStatuses.Widower),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: MaritalStatuses.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static MaritalStatusesNames(itemType: MaritalStatuses) {
    switch (itemType) {
      case MaritalStatuses.UnMarried:
        return "ENUMS.MARITAL_STATUSES.UnMarried";
      case MaritalStatuses.Married:
        return "ENUMS.MARITAL_STATUSES.Married";
      case MaritalStatuses.Divorced:
        return "ENUMS.MARITAL_STATUSES.Divorced";
      case MaritalStatuses.LiveInRelationship:
        return "ENUMS.MARITAL_STATUSES.LiveInRelationship";
      // case MaritalStatuses.Separated:
      //   return "ENUMS.MARITAL_STATUSES.Separated";
      case MaritalStatuses.Widow:
        return "ENUMS.MARITAL_STATUSES.Widow";
      case MaritalStatuses.Widower:
        return "ENUMS.MARITAL_STATUSES.Widower";
      default:
        return "";
    }
  }


  public static MaritalStatusesListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: MaritalStatuses.UnMarried,
        Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.UnMarried),
      },
      {
        Ref: MaritalStatuses.Married,
        Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.Married),
      },
      {
        Ref: MaritalStatuses.Divorced,
        Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.Divorced),
      },
      {
        Ref: MaritalStatuses.LiveInRelationship,
        Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.LiveInRelationship),
      },
      // {
      //   Ref: MaritalStatuses.Separated,
      //   Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.Separated),
      // },
      {
        Ref: MaritalStatuses.Widow,
        Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.Widow),
      },
      {
        Ref: MaritalStatuses.Widower,
        Name: DomainEnums.MaritalStatusesNames(MaritalStatuses.Widower),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: MaritalStatuses.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static HonorificsName(itemType: Honorifics) {
    switch (itemType) {
      case Honorifics.Mr:
        return "Mr. ";
      case Honorifics.Mrs:
        return "Mrs.";
      case Honorifics.Ms:
        return "Ms.";
      case Honorifics.Miss:
        return "Miss.";
      case Honorifics.Dr:
        return "Dr.";
      case Honorifics.Prof:
        return "Prof.";
      default:
        return "";
    }
  }

  public static HonorificsList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: Honorifics.Mr,
        Name: DomainEnums.HonorificsName(Honorifics.Mr),
      },
      {
        Ref: Honorifics.Mrs,
        Name: DomainEnums.HonorificsName(Honorifics.Mrs),
      },
      {
        Ref: Honorifics.Ms,
        Name: DomainEnums.HonorificsName(Honorifics.Ms),
      },
      {
        Ref: Honorifics.Miss,
        Name: DomainEnums.HonorificsName(Honorifics.Miss),
      },
      {
        Ref: Honorifics.Dr,
        Name: DomainEnums.HonorificsName(Honorifics.Dr),
      },
      {
        Ref: Honorifics.Prof,
        Name: DomainEnums.HonorificsName(Honorifics.Prof),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: Honorifics.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

    public static HonorificsNames(itemType: Honorifics) {
    switch (itemType) {
      case Honorifics.Mr:
        return "ENUMS.HONORIFICS.Mr";
      case Honorifics.Mrs:
        return "ENUMS.HONORIFICS.Mrs";
      case Honorifics.Ms:
        return "ENUMS.HONORIFICS.Ms";
      case Honorifics.Miss:
        return "ENUMS.HONORIFICS.Miss";
      case Honorifics.Dr:
        return "ENUMS.HONORIFICS.Dr";
      case Honorifics.Prof:
        return "ENUMS.HONORIFICS.Prof";
      default:
        return "";
    }
  }

  public static HonorificsListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: Honorifics.Mr,
        Name: DomainEnums.HonorificsNames(Honorifics.Mr),
      },
      {
        Ref: Honorifics.Mrs,
        Name: DomainEnums.HonorificsNames(Honorifics.Mrs),
      },
      {
        Ref: Honorifics.Ms,
        Name: DomainEnums.HonorificsNames(Honorifics.Ms),
      },
      {
        Ref: Honorifics.Miss,
        Name: DomainEnums.HonorificsNames(Honorifics.Miss),
      },
      { 
        Ref: Honorifics.Dr,
        Name: DomainEnums.HonorificsNames(Honorifics.Dr),   
      },
      {
        Ref: Honorifics.Prof,
        Name: DomainEnums.HonorificsNames(Honorifics.Prof),
      },

    ];
    if (withAllOption) {
      let allEntry = {
        Ref: Honorifics.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  // ============= ActivityTypes Start ===============

  public static ActivityTypeName(ActivityType: ActivityTypes) {
    switch (ActivityType) {
      case ActivityTypes.RoutineActivity:
        return "Routine Activity";
      case ActivityTypes.HWC:
        return "HWC";
      case ActivityTypes.StateGovernmentAllowance:
        return "State Government Allowance";
      case ActivityTypes.HBNC:
        return "HBNC ";
      case ActivityTypes.NationalDewormingDay:
        return "National Deworming Day ";
      default:
        return "";
    }
  }

  public static ActivityTypeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: ActivityTypes.RoutineActivity,
        Name: DomainEnums.ActivityTypeName(ActivityTypes.RoutineActivity),
      },
      {
        Ref: ActivityTypes.HWC,
        Name: DomainEnums.ActivityTypeName(ActivityTypes.HWC),
      },
      {
        Ref: ActivityTypes.StateGovernmentAllowance,
        Name: DomainEnums.ActivityTypeName(
          ActivityTypes.StateGovernmentAllowance,
        ),
      },
      {
        Ref: ActivityTypes.HBNC,
        Name: DomainEnums.ActivityTypeName(ActivityTypes.HBNC),
      },
      {
        Ref: ActivityTypes.NationalDewormingDay,
        Name: DomainEnums.ActivityTypeName(ActivityTypes.NationalDewormingDay),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // ============= ActivityTypes End  ===============

  // ============= ActivityFrequencyTypes Start For Dev Extreme Dropdown  ===============

  public static ActivityFrequencyTypeName(
    ActivityFrequencyType: ActivityFrequencyTypes,
  ) {
    switch (ActivityFrequencyType) {
      case ActivityFrequencyTypes.Monthly:
        return "Monthly";
      case ActivityFrequencyTypes.Yearly:
        return "Yearly";
      default:
        return "";
    }
  }

  public static ActivityFrequencyTypeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: ActivityFrequencyTypes.Monthly,
        Name: DomainEnums.ActivityFrequencyTypeName(
          ActivityFrequencyTypes.Monthly,
        ),
      },
      {
        Ref: ActivityFrequencyTypes.Yearly,
        Name: DomainEnums.ActivityFrequencyTypeName(
          ActivityFrequencyTypes.Yearly,
        ),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static ReportFilterTypesName(itemType: ReportFilterTypes) {
    switch (itemType) {
      case ReportFilterTypes.Monthly:
        return "Monthly";
      case ReportFilterTypes.Quarterly:
        return "Quarterly";
      case ReportFilterTypes.HalfYearly:
        return "Half Yearly";
      case ReportFilterTypes.Yearly:
        return "Yearly";
      case ReportFilterTypes.Custom:
        return "Custom";
      default:
        return "";
    }
  }

  public static ReportFilterTypesList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: ReportFilterTypes.Monthly,
        Name: DomainEnums.ReportFilterTypesName(ReportFilterTypes.Monthly),
      },
      {
        Ref: ReportFilterTypes.Quarterly,
        Name: DomainEnums.ReportFilterTypesName(ReportFilterTypes.Quarterly),
      },
      {
        Ref: ReportFilterTypes.HalfYearly,
        Name: DomainEnums.ReportFilterTypesName(ReportFilterTypes.HalfYearly),
      },
      {
        Ref: ReportFilterTypes.Yearly,
        Name: DomainEnums.ReportFilterTypesName(ReportFilterTypes.Yearly),
      },
      {
        Ref: ReportFilterTypes.Custom,
        Name: DomainEnums.ReportFilterTypesName(ReportFilterTypes.Custom),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: ReportFilterTypes.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static ReportFilterTypesNames(itemType: ReportFilterTypes) {
    switch (itemType) {
      case ReportFilterTypes.Monthly:
        return "ENUMS.REPORT_FILTER_TYPES.Monthly";
      case ReportFilterTypes.Quarterly:
        return "ENUMS.REPORT_FILTER_TYPES.Quarterly";
      case ReportFilterTypes.HalfYearly:
        return "ENUMS.REPORT_FILTER_TYPES.HalfYearly";
      case ReportFilterTypes.Yearly:
        return "ENUMS.REPORT_FILTER_TYPES.Yearly";
      case ReportFilterTypes.Custom:
        return "ENUMS.REPORT_FILTER_TYPES.Custom";
      default:
        return "";
    }
  }

  public static ReportFilterTypesListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: ReportFilterTypes.Monthly,
        Name: DomainEnums.ReportFilterTypesNames(ReportFilterTypes.Monthly),
      },
      {
        Ref: ReportFilterTypes.Quarterly,
        Name: DomainEnums.ReportFilterTypesNames(ReportFilterTypes.Quarterly),
      },
      {
        Ref: ReportFilterTypes.HalfYearly,
        Name: DomainEnums.ReportFilterTypesNames(ReportFilterTypes.HalfYearly),
      },
      {
        Ref: ReportFilterTypes.Yearly,
        Name: DomainEnums.ReportFilterTypesNames(ReportFilterTypes.Yearly),
      },
      {
        Ref: ReportFilterTypes.Custom,
        Name: DomainEnums.ReportFilterTypesNames(ReportFilterTypes.Custom),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: ReportFilterTypes.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static IncentiveRolesTypesName(itemType: IncentiveRoles) {
    switch (itemType) {
      case IncentiveRoles.AF:
        return "AF ";
      case IncentiveRoles.Asha:
        return "Asha";
      // case IncentiveRoles.AshaAndAF:
      //   return "Asha And AF";
      default:
        return "";
    }
  }

  public static IncentiveRolesList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: IncentiveRoles.AF,
        Name: DomainEnums.IncentiveRolesTypesName(IncentiveRoles.AF),
      },
      {
        Ref: IncentiveRoles.Asha,
        Name: DomainEnums.IncentiveRolesTypesName(IncentiveRoles.Asha),
      },
      // {
      //   Ref: IncentiveRoles.AshaAndAF,
      //   Name: DomainEnums.IncentiveRolesTypesName(IncentiveRoles.AshaAndAF),
      // },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: IncentiveRoles.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }


  public static QuarterName(itemType: Quarter) {
    switch (itemType) {
      case Quarter.First_Quarter:
        return "First Quarter";
      case Quarter.Second_Quarter:
        return "Second Quarter";
      case Quarter.Third_Quarter:
        return "Third Quarter";
      case Quarter.Fourth_Quarter:
        return "Fourth Quarter";
      default:
        return "";
    }
  }


  public static QuarterTypesList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: Quarter.First_Quarter,
        Name: DomainEnums.QuarterName(Quarter.First_Quarter),
      },
      {
        Ref: Quarter.Second_Quarter,
        Name: DomainEnums.QuarterName(Quarter.Second_Quarter),
      },
      {
        Ref: Quarter.Third_Quarter,
        Name: DomainEnums.QuarterName(Quarter.Third_Quarter),
      },
      {
        Ref: Quarter.Fourth_Quarter,
        Name: DomainEnums.QuarterName(Quarter.Fourth_Quarter),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: Quarter.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }


  public static QuarterNames(itemType: Quarter) {
    switch (itemType) {
      case Quarter.First_Quarter:
        return "ENUMS.QUARTERS.First_Quarter";
      case Quarter.Second_Quarter:
        return "ENUMS.QUARTERS.Second_Quarter";
      case Quarter.Third_Quarter:
        return "ENUMS.QUARTERS.Third_Quarter";
      case Quarter.Fourth_Quarter:
        return "ENUMS.QUARTERS.Fourth_Quarter";
      default:
        return "";
    }
  }


  public static QuarterTypesListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: Quarter.First_Quarter,
        Name: DomainEnums.QuarterNames(Quarter.First_Quarter),
      },
      {
        Ref: Quarter.Second_Quarter,
        Name: DomainEnums.QuarterNames(Quarter.Second_Quarter),
      },
      {
        Ref: Quarter.Third_Quarter,
        Name: DomainEnums.QuarterNames(Quarter.Third_Quarter),
      },
      {
        Ref: Quarter.Fourth_Quarter,
        Name: DomainEnums.QuarterNames(Quarter.Fourth_Quarter),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: Quarter.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static HalfYearName(itemType: HalfYear) {
    switch (itemType) {
      case HalfYear.First_Half:
        return "First Half";
      case HalfYear.Second_Half:
        return "Second Half";
      default:
        return "";
    }
  }


  public static HalfYearList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: HalfYear.First_Half,
        Name: DomainEnums.HalfYearName(HalfYear.First_Half),
      },
      {
        Ref: HalfYear.Second_Half,
        Name: DomainEnums.HalfYearName(HalfYear.Second_Half),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: HalfYear.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static HalfYearNames(itemType: HalfYear) {
    switch (itemType) {
      case HalfYear.First_Half:
        return "ENUMS.HALF_YEAR.FirstHalf";
      case HalfYear.Second_Half:
        return "ENUMS.HALF_YEAR.SecondHalf";
      default:
        return "";
    }
  }


  public static HalfYearListLang(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: HalfYear.First_Half,
        Name: DomainEnums.HalfYearNames(HalfYear.First_Half),
      },
      {
        Ref: HalfYear.Second_Half,
        Name: DomainEnums.HalfYearNames(HalfYear.Second_Half),
      },
    ];
    if (withAllOption) {
      let allEntry = {
        Ref: HalfYear.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }
    return result;
  }

  public static SystemDefinedTrainingTypeName(
    itemType: SystemDefinedTrainingType,
  ) {
    switch (itemType) {
      case SystemDefinedTrainingType.InductionTraining:
        return "Induction Training ";
      case SystemDefinedTrainingType.HBNC4thModule:
        return "HBNC 4th Module";
      case SystemDefinedTrainingType.HBNC6thModule:
        return "HBNC 6th Module";
      case SystemDefinedTrainingType.HBNC7thModule:
        return "HBNC 7th Module";
      case SystemDefinedTrainingType.HBYC:
        return "HBYC";
      default:
        return "";
    }
  }

  public static SystemDefinedTrainingTypeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: SystemDefinedTrainingType.InductionTraining,
        Name: DomainEnums.SystemDefinedTrainingTypeName(
          SystemDefinedTrainingType.InductionTraining,
        ),
      },
      {
        Ref: SystemDefinedTrainingType.HBNC4thModule,
        Name: DomainEnums.SystemDefinedTrainingTypeName(
          SystemDefinedTrainingType.HBNC4thModule,
        ),
      },
      {
        Ref: SystemDefinedTrainingType.HBNC6thModule,
        Name: DomainEnums.SystemDefinedTrainingTypeName(
          SystemDefinedTrainingType.HBNC6thModule,
        ),
      },
      {
        Ref: SystemDefinedTrainingType.HBNC7thModule,
        Name: DomainEnums.SystemDefinedTrainingTypeName(
          SystemDefinedTrainingType.HBNC7thModule,
        ),
      },
      {
        Ref: SystemDefinedTrainingType.HBYC,
        Name: DomainEnums.SystemDefinedTrainingTypeName(
          SystemDefinedTrainingType.HBYC,
        ),
      },
    ];
    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static ReportModeName(itemType: ReportModes) {
    switch (itemType) {
      case ReportModes.Detail:
        return "Detail";
      case ReportModes.Cumulative:
        return "Cumulative";
      default:
        return "";
    }
  }

  public static ReportModeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: ReportModes.Detail,
        Name: DomainEnums.ReportModeName(ReportModes.Detail),
      },
      {
        Ref: ReportModes.Cumulative,
        Name: DomainEnums.ReportModeName(ReportModes.Cumulative),
      },
    ];
    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }
    return result;
  }

  public static CumulativeReportLimitName(itemType: CumulativeReportLimits) {
    switch (itemType) {
      case CumulativeReportLimits.UPTOBlock:
        return "UPTO Block";
      case CumulativeReportLimits.UPTOPHC:
        return "UPTO PHC";
      case CumulativeReportLimits.UPTOAF:
        return "UPTO AF";
      default:
        return "";
    }
  }

  public static CumulativeReportLimitList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: CumulativeReportLimits.UPTOBlock,
        Name: DomainEnums.CumulativeReportLimitName(
          CumulativeReportLimits.UPTOBlock,
        ),
      },
      {
        Ref: CumulativeReportLimits.UPTOPHC,
        Name: DomainEnums.CumulativeReportLimitName(
          CumulativeReportLimits.UPTOPHC,
        ),
      },
      {
        Ref: CumulativeReportLimits.UPTOAF,
        Name: DomainEnums.CumulativeReportLimitName(
          CumulativeReportLimits.UPTOAF,
        ),
      },
    ];
    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }
    return result;
  }

  public static BirthAgeTypesName(item: BirthAgeTypes) {
    switch (item) {
      case BirthAgeTypes.UptoThreeMonth:
        return "३ महिन्यापर्यंत";
      case BirthAgeTypes.UptoSixMonth:
        return "६ महिन्यापर्यंत";
      case BirthAgeTypes.UptoNineMonth:
        return "९ महिन्यापर्यंत";
      case BirthAgeTypes.UptoTwelveMonth:
        return "१२ महिन्यापर्यंत";
      case BirthAgeTypes.UptoFifteenMonth:
        return "१५ महिन्यापर्यंत";
      default:
        return "";
    }
  }

  public static BirthAgeTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: BirthAgeTypes.None,
      //   Name: DomainEnums.BirthAgeTypesName(BirthAgeTypes.None),
      // },
      {
        Ref: BirthAgeTypes.UptoThreeMonth,
        Name: DomainEnums.BirthAgeTypesName(BirthAgeTypes.UptoThreeMonth),
      },
      {
        Ref: BirthAgeTypes.UptoSixMonth,
        Name: DomainEnums.BirthAgeTypesName(BirthAgeTypes.UptoSixMonth),
      },
      {
        Ref: BirthAgeTypes.UptoNineMonth,
        Name: DomainEnums.BirthAgeTypesName(BirthAgeTypes.UptoNineMonth),
      },
      {
        Ref: BirthAgeTypes.UptoTwelveMonth,
        Name: DomainEnums.BirthAgeTypesName(BirthAgeTypes.UptoTwelveMonth),
      },
      {
        Ref: BirthAgeTypes.UptoFifteenMonth,
        Name: DomainEnums.BirthAgeTypesName(BirthAgeTypes.UptoFifteenMonth),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static GendersName(item: Genders) {
    switch (item) {
      case Genders.Male:
        return "Male";
      case Genders.Female:
        return "Female";
      case Genders.Transgender:
        return "Transgender";
      default:
        return "";
    }
  }



  public static GendersList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: Genders.Male,
        Name: DomainEnums.GendersName(Genders.Male),
      },
      {
        Ref: Genders.Female,
        Name: DomainEnums.GendersName(Genders.Female),
      },
      {
        Ref: Genders.Transgender,
        Name: DomainEnums.GendersName(Genders.Transgender),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }


  public static GendersNames(item: Genders) {
    switch (item) {
      case Genders.Male:
        return "ENUMS.GENDERS.Male";
      case Genders.Female:
        return "ENUMS.GENDERS.Female";
      case Genders.Transgender:
        return "ENUMS.GENDERS.Transgender";
      default:
        return "";
    }
  }
  public static GendersListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: Genders.Male,
        Name: DomainEnums.GendersNames(Genders.Male),
      },
      {
        Ref: Genders.Female,
        Name: DomainEnums.GendersNames(Genders.Female),
      },
      {
        Ref: Genders.Transgender,
        Name: DomainEnums.GendersNames(Genders.Transgender),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // ============= Contraceptive Pills Types Start ===============

  public static ContraceptivePillsTypeName(
    ContraceptivePillsType: ContraceptivePillsTypes,
  ) {
    switch (ContraceptivePillsType) {
      case ContraceptivePillsTypes.Condom:
        return "Condom";
      case ContraceptivePillsTypes.Mala_N:
        return "Mala-N";
      case ContraceptivePillsTypes.ECPills:
        return "EC Pills";
      case ContraceptivePillsTypes.Chhaya:
        return "Chhaya";
      default:
        return "";
    }
  }

  public static ContraceptivePillsTypeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: ContraceptivePillsTypes.Condom,
        Name: DomainEnums.ContraceptivePillsTypeName(
          ContraceptivePillsTypes.Condom,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.Mala_N,
        Name: DomainEnums.ContraceptivePillsTypeName(
          ContraceptivePillsTypes.Mala_N,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.ECPills,
        Name: DomainEnums.ContraceptivePillsTypeName(
          ContraceptivePillsTypes.ECPills,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.Chhaya,
        Name: DomainEnums.ContraceptivePillsTypeName(
          ContraceptivePillsTypes.Chhaya,
        ),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // ============= Contraceptive Pills Types End  ===============

  public static ContraceptivePillsTypeNameLang(
    ContraceptivePillsType: ContraceptivePillsTypes,
  ) {
    switch (ContraceptivePillsType) {
      case ContraceptivePillsTypes.Condom:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.Condom";
      case ContraceptivePillsTypes.Mala_N:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.Mala_N";
      case ContraceptivePillsTypes.ECPills:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.ECPills";
      case ContraceptivePillsTypes.Chhaya:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.Chhaya";
        case ContraceptivePillsTypes.Antara:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.Antara";
        case ContraceptivePillsTypes.PPIUCD:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.PPIUCD";
         case ContraceptivePillsTypes.PAIUCD:
        return "ENUMS.CONTRACEPTIVE_PILLS_TYPES.PAIUCD";
      default:
        return "";
    }
  }

  public static ContraceptivePillsTypeListlang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: ContraceptivePillsTypes.Condom,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.Condom,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.Mala_N,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.Mala_N,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.ECPills,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.ECPills,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.Chhaya,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.Chhaya,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.Antara,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.Antara,
        ),
      },
      {
        Ref: ContraceptivePillsTypes.PPIUCD,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.PPIUCD,
        ),
      },
       {
        Ref: ContraceptivePillsTypes.PAIUCD,
        Name: DomainEnums.ContraceptivePillsTypeNameLang(
          ContraceptivePillsTypes.PAIUCD,
        ),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // ============= Contraceptive Pills Types bi-lingual End  ===============






  public static RequestStatusesName(requestStatuses: RequestStatuses) {
    switch (requestStatuses) {
      case RequestStatuses.Pending:
        return "Pending";
      case RequestStatuses.Cancelled:
        return "Cancelled ";
      default:
        return "";
    }
  }

  public static RequestStatusesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: RequestStatuses.Pending,
        Name: DomainEnums.RequestStatusesName(RequestStatuses.Pending),
      },
      {
        Ref: RequestStatuses.Cancelled,
        Name: DomainEnums.RequestStatusesName(RequestStatuses.Cancelled),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static ApprovalStatusesName(approvalStatuse: ApprovalStatuses) {
    switch (approvalStatuse) {
      case ApprovalStatuses.Approved:
        return "Approved";
      case ApprovalStatuses.Rejected:
        return "Rejected";
      default:
        return "";
    }
  }

  public static ApprovalStatusesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: ApprovalStatuses.Approved,
        Name: DomainEnums.ApprovalStatusesName(ApprovalStatuses.Approved),
      },
      {
        Ref: ApprovalStatuses.Rejected,
        Name: DomainEnums.ApprovalStatusesName(ApprovalStatuses.Rejected),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static OperationalModesName(mode: OperationalModes) {
    switch (mode) {
      case OperationalModes.CanAdd:
        return "Add";

      case OperationalModes.CanEdit:
        return "Edit";

      case OperationalModes.CanView:
        return "View";

      default:
        return "";
    }
  }

  public static OperationalModesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: OperationalModes.CanAdd,
        Name: DomainEnums.OperationalModesName(OperationalModes.CanAdd),
      },
      {
        Ref: OperationalModes.CanEdit,
        Name: DomainEnums.OperationalModesName(OperationalModes.CanEdit),
      },
      {
        Ref: OperationalModes.CanView,
        Name: DomainEnums.OperationalModesName(OperationalModes.CanView),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }


  // ============= Contraceptive Pills Types Start ===============

  public static AnemiaMuktaBharatTypeName(
    AnemiaMuktaBharatType: AnemiaMuktaBharatTypes,
  ) {
    switch (AnemiaMuktaBharatType) {
      case AnemiaMuktaBharatTypes.IFA_Tablet_Red:
        return "IFA Tablet (Red)";
      case AnemiaMuktaBharatTypes.IFA_Syrup:
        return "IFA Syrup";
      default:
        return "";
    }
  }

  public static AnemiaMuktaBharatTypeList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: AnemiaMuktaBharatTypes.IFA_Tablet_Red,
        Name: DomainEnums.AnemiaMuktaBharatTypeName(
          AnemiaMuktaBharatTypes.IFA_Tablet_Red,
        ),
      },
      {
        Ref: AnemiaMuktaBharatTypes.IFA_Syrup,
        Name: DomainEnums.AnemiaMuktaBharatTypeName(
          AnemiaMuktaBharatTypes.IFA_Syrup,
        ),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }
  // ============= Contraceptive Pills Types End  ===============
  // ============= Contraceptive Pills Types End  ===============
  public static StateIncentiveTypesName(itemType: StateIncentiveTypes) {
    switch (itemType) {
      case StateIncentiveTypes.Sanction:
        return "Sanction";
      case StateIncentiveTypes.Given:
        return "Given";
      case StateIncentiveTypes.Remaining:
        return "Remaining";
      default:
        return "";
    }
  }

  public static StateIncentiveTypesList(
    withAllOption: boolean = false,
    allOptionName: string = "<All>",
  ) {
    let result = [
      {
        Ref: StateIncentiveTypes.Sanction,
        Name: DomainEnums.StateIncentiveTypesName(StateIncentiveTypes.Sanction),
      },
      {
        Ref: StateIncentiveTypes.Given,
        Name: DomainEnums.StateIncentiveTypesName(StateIncentiveTypes.Given),
      },
      {
        Ref: StateIncentiveTypes.Remaining,
        Name: DomainEnums.StateIncentiveTypesName(StateIncentiveTypes.Remaining),
      },
    ];

    if (withAllOption) {
      let allEntry = {
        Ref: StateIncentiveTypes.None,
        Name: allOptionName,
      };
      result.unshift(allEntry);
    }

    return result;
  }
  // ============= Contraceptive Pills Types End  ===============

  // ============= Economics status Types End  ==============
  public static EconomicStatusesName(item: EconomicStatuses) {
    switch (item) {
      case EconomicStatuses.BPL:
        return "BPL";
      case EconomicStatuses.APL:
        return "APL";
      case EconomicStatuses.WhiteCard:
        return "White Card";
      default:
        return "";
    }
  }

  public static EconomicStatusesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: EconomicStatuses.None,
        Name: DomainEnums.EconomicStatusesName(EconomicStatuses.None),
      },
      {
        Ref: EconomicStatuses.BPL,
        Name: DomainEnums.EconomicStatusesName(EconomicStatuses.BPL),
      },
      {
        Ref: EconomicStatuses.APL,
        Name: DomainEnums.EconomicStatusesName(EconomicStatuses.APL),
      },
      {
        Ref: EconomicStatuses.WhiteCard,
        Name: DomainEnums.EconomicStatusesName(EconomicStatuses.WhiteCard),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static EconomicStatusesNames(item: EconomicStatuses) {
    switch (item) {
      case EconomicStatuses.BPL:
        return "ENUMS.ECONOMIC_STATUSES.BPL";
      case EconomicStatuses.APL:
        return "ENUMS.ECONOMIC_STATUSES.APL";
      case EconomicStatuses.WhiteCard:
        return "ENUMS.ECONOMIC_STATUSES.WHITE_CARD";
      default:
        return "";
    }
  }

  public static EconomicStatusesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: EconomicStatuses.None,
      //   Name: DomainEnums.EconomicStatusesNames(EconomicStatuses.None),
      // },
      {
        Ref: EconomicStatuses.BPL,
        Name: DomainEnums.EconomicStatusesNames(EconomicStatuses.BPL),
      },
      {
        Ref: EconomicStatuses.APL,
        Name: DomainEnums.EconomicStatusesNames(EconomicStatuses.APL),
      },
      {
        Ref: EconomicStatuses.WhiteCard,
        Name: DomainEnums.EconomicStatusesNames(EconomicStatuses.WhiteCard),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }
  // ============= Family Types End  ===============
  public static FamilyTypesName(item: FamilyTypes) {
    switch (item) {
      case FamilyTypes.Nuclear:
        return "Nuclear";
      case FamilyTypes.Joint:
        return "Joint";
      default:
        return "";
    }
  }

  public static FamilyTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: FamilyTypes.None,
      //   Name: DomainEnums.FamilyTypesName(FamilyTypes.None),
      // },
      {
        Ref: FamilyTypes.Nuclear,
        Name: DomainEnums.FamilyTypesName(FamilyTypes.Nuclear),
      },
      {
        Ref: FamilyTypes.Joint,
        Name: DomainEnums.FamilyTypesName(FamilyTypes.Joint),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static FamilyTypesNames(item: FamilyTypes) {
    switch (item) {
      case FamilyTypes.Nuclear:
        return "ENUMS.FAMILY_TYPES.Nuclear";
      case FamilyTypes.Joint:
        return "ENUMS.FAMILY_TYPES.Joint";
      default:
        return "";
    }
  }

  public static FamilyTypesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: FamilyTypes.None,
      //   Name: DomainEnums.FamilyTypesName(FamilyTypes.None),
      // },
      {
        Ref: FamilyTypes.Nuclear,
        Name: DomainEnums.FamilyTypesNames(FamilyTypes.Nuclear),
      },
      {
        Ref: FamilyTypes.Joint,
        Name: DomainEnums.FamilyTypesNames(FamilyTypes.Joint),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // ============= MigrationStatuses Types End  ===============
  public static MigrationStatusesName(item: MigrationStatuses) {
    switch (item) {
      case MigrationStatuses.Seasonal:
        return "Seasonal";
      case MigrationStatuses.Permanent:
        return "Permanent";
      case MigrationStatuses.Temporary:
        return "Temporary";
      default:
        return "";
    }
  }

  public static MigrationStatusesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: MigrationStatuses.None,
      //   Name: DomainEnums.MigrationStatusesName(MigrationStatuses.None),
      // },
      {
        Ref: MigrationStatuses.Seasonal,
        Name: DomainEnums.MigrationStatusesName(MigrationStatuses.Seasonal),
      },
      {
        Ref: MigrationStatuses.Permanent,
        Name: DomainEnums.MigrationStatusesName(MigrationStatuses.Permanent),
      },
      {
        Ref: MigrationStatuses.Temporary,
        Name: DomainEnums.MigrationStatusesName(MigrationStatuses.Temporary),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static MigrationStatusesNames(item: MigrationStatuses) {
    switch (item) {
      case MigrationStatuses.Seasonal:
        return "ENUMS.MIGRATION_STATUSES.Seasonal";
      case MigrationStatuses.Permanent:
        return "ENUMS.MIGRATION_STATUSES.Permanent";
      case MigrationStatuses.Temporary:
        return "ENUMS.MIGRATION_STATUSES.Temporary";
      default:
        return "";
    }
  }

  public static MigrationStatusesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: MigrationStatuses.None,
      //   Name: DomainEnums.MigrationStatusesName(MigrationStatuses.None),
      // },
      {
        Ref: MigrationStatuses.Seasonal,
        Name: DomainEnums.MigrationStatusesNames(MigrationStatuses.Seasonal),
      },
      {
        Ref: MigrationStatuses.Permanent,
        Name: DomainEnums.MigrationStatusesNames(MigrationStatuses.Permanent),
      },
      {
        Ref: MigrationStatuses.Temporary,
        Name: DomainEnums.MigrationStatusesNames(MigrationStatuses.Temporary),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }
  // ============= Blood Groups End  ===============
  public static BloodGroupsName(item: BloodGroups) {
    switch (item) {
      case BloodGroups.APositive:
        return "A+";
      case BloodGroups.ANegative:
        return "A-";
      case BloodGroups.BPositive:
        return "B+";
      case BloodGroups.BNegative:
        return "B-";
      case BloodGroups.ABPositive:
        return "AB+";
      case BloodGroups.ABNegative:
        return "AB-";
      case BloodGroups.OPositive:
        return "O+";
      case BloodGroups.ONegative:
        return "O-";
      default:
        return "";
    }
  }

  public static BloodGroupsList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // {
      //   Ref: BloodGroups.None,
      //   Name: DomainEnums.BloodGroupsName(BloodGroups.None),
      // },
      {
        Ref: BloodGroups.APositive,
        Name: DomainEnums.BloodGroupsName(BloodGroups.APositive),
      },
      {
        Ref: BloodGroups.ANegative,
        Name: DomainEnums.BloodGroupsName(BloodGroups.ANegative),
      },
      {
        Ref: BloodGroups.BPositive,
        Name: DomainEnums.BloodGroupsName(BloodGroups.BPositive),
      },
      {
        Ref: BloodGroups.BNegative,
        Name: DomainEnums.BloodGroupsName(BloodGroups.BNegative),
      },
      {
        Ref: BloodGroups.ABPositive,
        Name: DomainEnums.BloodGroupsName(BloodGroups.ABPositive),
      },
      {
        Ref: BloodGroups.ABNegative,
        Name: DomainEnums.BloodGroupsName(BloodGroups.ABNegative),
      },
      {
        Ref: BloodGroups.OPositive,
        Name: DomainEnums.BloodGroupsName(BloodGroups.OPositive),
      },
      {
        Ref: BloodGroups.ONegative,
        Name: DomainEnums.BloodGroupsName(BloodGroups.ONegative),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static BloodGroupsListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // { Ref: Educations.None, Name: DomainEnums.EducationsName(Educations.None) },
      { Ref: BloodGroups.ABNegative, Name: DomainEnums.BloodGroupsName(BloodGroups.ABNegative) },
      { Ref: BloodGroups.ABPositive, Name: DomainEnums.BloodGroupsName(BloodGroups.ABPositive) },
      { Ref: BloodGroups.ANegative, Name: DomainEnums.BloodGroupsName(BloodGroups.ANegative) },
      { Ref: BloodGroups.APositive, Name: DomainEnums.BloodGroupsName(BloodGroups.APositive) },
      { Ref: BloodGroups.BNegative, Name: DomainEnums.BloodGroupsName(BloodGroups.BNegative) },
      { Ref: BloodGroups.BPositive, Name: DomainEnums.BloodGroupsName(BloodGroups.BPositive) },
      { Ref: BloodGroups.ONegative, Name: DomainEnums.BloodGroupsName(BloodGroups.ONegative) },
      { Ref: BloodGroups.OPositive, Name: DomainEnums.BloodGroupsName(BloodGroups.OPositive) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }
  // ============= Education  ===============

  public static EducationsName(item: Educations) {
    switch (item) {
      case Educations.Uneducated:
        return "Uneducated";
      case Educations.Below8th:
        return "Below 8th";
      case Educations.Eighth:
        return "8th";
      case Educations.Tenth:
        return "10th";
      case Educations.JuniorCollege:
        return "Junior College";
      case Educations.Graduation:
        return "Graduation";
      case Educations.PostGraduation:
        return "Post Graduation";
      case Educations.Phd:
        return "PhD";
      case Educations.NA:
        return "NA";
      default:
        return "";
    }
  }

  public static EducationsList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // { Ref: Educations.None, Name: DomainEnums.EducationsName(Educations.None) },
      { Ref: Educations.Uneducated, Name: DomainEnums.EducationsName(Educations.Uneducated) },
      { Ref: Educations.Below8th, Name: DomainEnums.EducationsName(Educations.Below8th) },
      { Ref: Educations.Eighth, Name: DomainEnums.EducationsName(Educations.Eighth) },
      { Ref: Educations.Tenth, Name: DomainEnums.EducationsName(Educations.Tenth) },
      { Ref: Educations.JuniorCollege, Name: DomainEnums.EducationsName(Educations.JuniorCollege) },
      { Ref: Educations.Graduation, Name: DomainEnums.EducationsName(Educations.Graduation) },
      { Ref: Educations.PostGraduation, Name: DomainEnums.EducationsName(Educations.PostGraduation) },
      { Ref: Educations.Phd, Name: DomainEnums.EducationsName(Educations.Phd) },
      { Ref: Educations.NA, Name: DomainEnums.EducationsName(Educations.NA) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  public static EducationsNames(item: Educations) {
    switch (item) {
      case Educations.Uneducated:
        return "ENUMS.EDUCATIONS.Uneducated";
      case Educations.Below8th:
        return "ENUMS.EDUCATIONS.Below8th";
      case Educations.Eighth:
        return "ENUMS.EDUCATIONS.Eighth";
      case Educations.Tenth:
        return "ENUMS.EDUCATIONS.Tenth";
      case Educations.JuniorCollege:
        return "ENUMS.EDUCATIONS.JuniorCollege";
      case Educations.Graduation:
        return "ENUMS.EDUCATIONS.Graduation";
      case Educations.PostGraduation:
        return "ENUMS.EDUCATIONS.PostGraduation";
      case Educations.Phd:
        return "ENUMS.EDUCATIONS.Phd";
      case Educations.NA:
        return "ENUMS.EDUCATIONS.NA";
      default:
        return "";
    }
  }

  public static EducationsListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // { Ref: Educations.None, Name: DomainEnums.EducationsName(Educations.None) },
      { Ref: Educations.Uneducated, Name: DomainEnums.EducationsNames(Educations.Uneducated) },
      { Ref: Educations.Below8th, Name: DomainEnums.EducationsNames(Educations.Below8th) },
      { Ref: Educations.Eighth, Name: DomainEnums.EducationsNames(Educations.Eighth) },
      { Ref: Educations.Tenth, Name: DomainEnums.EducationsNames(Educations.Tenth) },
      { Ref: Educations.JuniorCollege, Name: DomainEnums.EducationsNames(Educations.JuniorCollege) },
      { Ref: Educations.Graduation, Name: DomainEnums.EducationsNames(Educations.Graduation) },
      { Ref: Educations.PostGraduation, Name: DomainEnums.EducationsNames(Educations.PostGraduation) },
      { Ref: Educations.Phd, Name: DomainEnums.EducationsNames(Educations.Phd) },
      { Ref: Educations.NA, Name: DomainEnums.EducationsNames(Educations.NA) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  // ============= Occupations  ===============

  public static OccupationsName(item: Occupations) {
    switch (item) {
      case Occupations.Employed:
        return "Employed";
      case Occupations.Unemployed:
        return "Unemployed";
      case Occupations.Student:
        return "Student";
      case Occupations.Farmer:
        return "Farmer";
      case Occupations.Business:
        return "Business";
      case Occupations.SelfEmployed:
        return "Self Employed";
      case Occupations.HomeMaker:
        return "Home Maker";
      case Occupations.Retired:
        return "Retired";
      case Occupations.NA:
        return "Not Applicable";
      default:
        return "";
    }
  }

  public static OccupationsList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // { Ref: Occupations.None, Name: DomainEnums.OccupationsName(Occupations.None) },
      { Ref: Occupations.Employed, Name: DomainEnums.OccupationsName(Occupations.Employed) },
      { Ref: Occupations.Unemployed, Name: DomainEnums.OccupationsName(Occupations.Unemployed) },
      { Ref: Occupations.Student, Name: DomainEnums.OccupationsName(Occupations.Student) },
      { Ref: Occupations.Farmer, Name: DomainEnums.OccupationsName(Occupations.Farmer) },
      { Ref: Occupations.Business, Name: DomainEnums.OccupationsName(Occupations.Business) },
      { Ref: Occupations.SelfEmployed, Name: DomainEnums.OccupationsName(Occupations.SelfEmployed) },
      { Ref: Occupations.HomeMaker, Name: DomainEnums.OccupationsName(Occupations.HomeMaker) },
      { Ref: Occupations.Retired, Name: DomainEnums.OccupationsName(Occupations.Retired) },
      { Ref: Occupations.NA, Name: DomainEnums.OccupationsName(Occupations.NA) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  public static OccupationsNames(item: Occupations) {
    switch (item) {
      case Occupations.Employed:
        return "ENUMS.OCCUPATIONS.Employed";
      case Occupations.Unemployed:
        return "ENUMS.OCCUPATIONS.Unemployed";
      case Occupations.Student:
        return "ENUMS.OCCUPATIONS.Student";
      case Occupations.Farmer:
        return "ENUMS.OCCUPATIONS.Farmer";
      case Occupations.Business:
        return "ENUMS.OCCUPATIONS.Business";
      case Occupations.SelfEmployed:
        return "ENUMS.OCCUPATIONS.SelfEmployed";
      case Occupations.HomeMaker:
        return "ENUMS.OCCUPATIONS.HomeMaker";
      case Occupations.Retired:
        return "ENUMS.OCCUPATIONS.Retired";
        case Occupations.Labour:
          return "ENUMS.OCCUPATIONS.Labour";
      case Occupations.NA:
        return "ENUMS.OCCUPATIONS.NA";
      default:
        return "";
    }
  }

  public static OccupationsListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // { Ref: Occupations.None, Name: DomainEnums.OccupationsName(Occupations.None) },
      { Ref: Occupations.Employed, Name: DomainEnums.OccupationsNames(Occupations.Employed) },
      { Ref: Occupations.Unemployed, Name: DomainEnums.OccupationsNames(Occupations.Unemployed) },
      { Ref: Occupations.Student, Name: DomainEnums.OccupationsNames(Occupations.Student) },
      { Ref: Occupations.Farmer, Name: DomainEnums.OccupationsNames(Occupations.Farmer) },
      { Ref: Occupations.Business, Name: DomainEnums.OccupationsNames(Occupations.Business) },
      { Ref: Occupations.SelfEmployed, Name: DomainEnums.OccupationsNames(Occupations.SelfEmployed) },
      { Ref: Occupations.HomeMaker, Name: DomainEnums.OccupationsNames(Occupations.HomeMaker) },
      { Ref: Occupations.Retired, Name: DomainEnums.OccupationsNames(Occupations.Retired) },
      { Ref: Occupations.Labour, Name: DomainEnums.OccupationsNames(Occupations.Labour) },
      { Ref: Occupations.NA, Name: DomainEnums.OccupationsNames(Occupations.NA) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  // ============= Languages  ===============

  public static LanguagesName(item: Languages) {
    switch (item) {
      case Languages.Marathi:
        return "Marathi";
      case Languages.English:
        return "English";
      default:
        return "";
    }
  }

  public static LanguagesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      // { Ref: Languages.None, Name: DomainEnums.LanguagesName(Languages.None) },
      { Ref: Languages.Marathi, Name: DomainEnums.LanguagesName(Languages.Marathi) },
      { Ref: Languages.English, Name: DomainEnums.LanguagesName(Languages.English) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  // Residency Statuses ==================================================================================

  public static ResidencyStatusesName(item: ResidencyStatuses) {
    switch (item) {
      case ResidencyStatuses.Native:
        return "Native";
      case ResidencyStatuses.Migrated:
        return "Migrated";
      default:
        return "";
    }
  }

  public static ResidencyStatusesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      { Ref: ResidencyStatuses.Native, Name: DomainEnums.ResidencyStatusesName(ResidencyStatuses.Native) },
      { Ref: ResidencyStatuses.Migrated, Name: DomainEnums.ResidencyStatusesName(ResidencyStatuses.Migrated) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  public static ResidencyStatusesNames(item: ResidencyStatuses) {
    switch (item) {
      case ResidencyStatuses.Native:
        return "ENUMS.RESIDENCYSTATUSES.Native";
      case ResidencyStatuses.Migrated:
        return "ENUMS.RESIDENCYSTATUSES.Migrated";
      default:
        return "";
    }
  }

  public static ResidencyStatusesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      { Ref: ResidencyStatuses.Native, Name: DomainEnums.ResidencyStatusesNames(ResidencyStatuses.Native) },
      { Ref: ResidencyStatuses.Migrated, Name: DomainEnums.ResidencyStatusesNames(ResidencyStatuses.Migrated) },
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  // ApprovalStatusesForFamilyRegistration =================================================================

  public static ApprovalStatusesForFamilyRegistrationName(item: ApprovalStatusesForFamilyRegistration) {
    switch (item) {
      case ApprovalStatusesForFamilyRegistration.Pending:
        return "Pending";
      case ApprovalStatusesForFamilyRegistration.Approved:
        return "Approved";
      case ApprovalStatusesForFamilyRegistration.Rejected:
        return "Rejected";
      case ApprovalStatusesForFamilyRegistration.Cancelled:
        return "Cancelled";
      case ApprovalStatusesForFamilyRegistration.ReturnForCorrection:
        return "Returned for Correction";
      case ApprovalStatusesForFamilyRegistration.CorrectionDone:
        return "Correction Done";
      default:
        return "";
    }
  }

  public static ApprovalStatusesForFamilyRegistrationNames(item: ApprovalStatusesForFamilyRegistration) {
    switch (item) {
      case ApprovalStatusesForFamilyRegistration.Pending:
        return "ENUMS.APPROVAL_STATUS.PENDING";
      case ApprovalStatusesForFamilyRegistration.Approved:
        return "ENUMS.APPROVAL_STATUS.APPROVED";
      case ApprovalStatusesForFamilyRegistration.Rejected:
        return "ENUMS.APPROVAL_STATUS.REJECTED";
      case ApprovalStatusesForFamilyRegistration.Cancelled:
        return "ENUMS.APPROVAL_STATUS.CANCELLED";
      case ApprovalStatusesForFamilyRegistration.ReturnForCorrection:
        return "ENUMS.APPROVAL_STATUS.RETURN_FOR_CORRECTION";
      case ApprovalStatusesForFamilyRegistration.CorrectionDone:
        return "ENUMS.APPROVAL_STATUS.CORRECTION_DONE";
      default:
        return "";
    }
  }

  public static ApprovalStatusesForFamilyRegistrationList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>"
  ) {
    let result = [
      {
        Ref: ApprovalStatusesForFamilyRegistration.None,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.None),
      },
      {
        Ref: ApprovalStatusesForFamilyRegistration.Pending,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.Pending),
      },
      {
        Ref: ApprovalStatusesForFamilyRegistration.Approved,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.Approved),
      },
      {
        Ref: ApprovalStatusesForFamilyRegistration.Rejected,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.Rejected),
      },
      {
        Ref: ApprovalStatusesForFamilyRegistration.Cancelled,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.Cancelled),
      },
      {
        Ref: ApprovalStatusesForFamilyRegistration.ReturnForCorrection,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.ReturnForCorrection),
      },
      {
        Ref: ApprovalStatusesForFamilyRegistration.CorrectionDone,
        Name: DomainEnums.ApprovalStatusesForFamilyRegistrationNames(ApprovalStatusesForFamilyRegistration.CorrectionDone),
      }
    ];

    if (includeAllOption) {
      result.unshift({ Ref: 0, Name: allOptionString });
    }

    return result;
  }

  //==================================================== Maata Register =================================================================
  // ========================= HospitalTypes  ==================

  public static HospitalTypesName(item: HospitalTypes) {
    switch (item) {
      case HospitalTypes.Private:
        return "Private";
      case HospitalTypes.Government:
        return "Government";
      default:
        return "";
    }
  }

  public static HospitalTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: HospitalTypes.Private,
        Name: DomainEnums.HospitalTypesName(HospitalTypes.Private),
      },
      {
        Ref: HospitalTypes.Government,
        Name: DomainEnums.HospitalTypesName(HospitalTypes.Government),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static HospitalTypesNames(item: HospitalTypes) {
    switch (item) {
      case HospitalTypes.Private:
        return "ENUMS.HOSPITAL_TYPES.Private";
      case HospitalTypes.Government:
        return "ENUMS.HOSPITAL_TYPES.Government";
      default:
        return "";
    }
  }

  public static HospitalTypesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: HospitalTypes.Private,
        Name: DomainEnums.HospitalTypesNames(HospitalTypes.Private),
      },
      {
        Ref: HospitalTypes.Government,
        Name: DomainEnums.HospitalTypesNames(HospitalTypes.Government),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // Delivery Type ================================================

  public static DeliveryTypesName(item: DeliveryTypes) {
    switch (item) {
      case DeliveryTypes.Normal:
        return "Normal";
      case DeliveryTypes.CSection:
        return "C-Section";
      case DeliveryTypes.AssistedVaginal:
        return "Assisted Vaginal";
      case DeliveryTypes.Preterm:
        return "Preterm";
      case DeliveryTypes.NotApplicable:
        return "Not Applicable";
      default:
        return "";
    }
  }

  public static DeliveryTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: DeliveryTypes.Normal,
        Name: DomainEnums.DeliveryTypesName(DeliveryTypes.Normal),
      },
      {
        Ref: DeliveryTypes.CSection,
        Name: DomainEnums.DeliveryTypesName(DeliveryTypes.CSection),
      },
      {
        Ref: DeliveryTypes.AssistedVaginal,
        Name: DomainEnums.DeliveryTypesName(DeliveryTypes.AssistedVaginal),
      },
      {
        Ref: DeliveryTypes.Preterm,
        Name: DomainEnums.DeliveryTypesName(DeliveryTypes.Preterm),
      },
      {
        Ref: DeliveryTypes.NotApplicable,
        Name: DomainEnums.DeliveryTypesName(DeliveryTypes.NotApplicable),
      }
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static DeliveryTypesNames(item: DeliveryTypes) {
    switch (item) {
      case DeliveryTypes.Normal:
        return "ENUMS.DELIVERY_TYPES.Normal";
      case DeliveryTypes.CSection:
        return "ENUMS.DELIVERY_TYPES.CSection";
      case DeliveryTypes.AssistedVaginal:
        return "ENUMS.DELIVERY_TYPES.AssistedVaginal";
      case DeliveryTypes.Preterm:
        return "ENUMS.DELIVERY_TYPES.Preterm";
      case DeliveryTypes.NotApplicable:
        return "ENUMS.DELIVERY_TYPES.NotApplicable";
      default:
        return "";
    }
  }

  public static DeliveryTypesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: DeliveryTypes.Normal,
        Name: DomainEnums.DeliveryTypesNames(DeliveryTypes.Normal),
      },
      {
        Ref: DeliveryTypes.CSection,
        Name: DomainEnums.DeliveryTypesNames(DeliveryTypes.CSection),
      },
      {
        Ref: DeliveryTypes.AssistedVaginal,
        Name: DomainEnums.DeliveryTypesNames(DeliveryTypes.AssistedVaginal),
      },
      {
        Ref: DeliveryTypes.Preterm,
        Name: DomainEnums.DeliveryTypesNames(DeliveryTypes.Preterm),
      },
      {
        Ref: DeliveryTypes.NotApplicable,
        Name: DomainEnums.DeliveryTypesNames(DeliveryTypes.NotApplicable),
      }
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // Pregnancy Outcome ========================================
  public static PregnancyOutcomeTypesName(item: PregnancyOutcomeTypes) {
    switch (item) {
      case PregnancyOutcomeTypes.LiveBirth:
        return "Live Birth";
      case PregnancyOutcomeTypes.StillBirth:
        return "Still Birth";
      case PregnancyOutcomeTypes.AbortionInduced:
        return "Abortion (Induced)";
      case PregnancyOutcomeTypes.Miscarriage:
        return "Miscarriage";
      default:
        return "";
    }
  }

  public static PregnancyOutcomeTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: PregnancyOutcomeTypes.LiveBirth,
        Name: DomainEnums.PregnancyOutcomeTypesName(PregnancyOutcomeTypes.LiveBirth),
      },
      {
        Ref: PregnancyOutcomeTypes.StillBirth,
        Name: DomainEnums.PregnancyOutcomeTypesName(PregnancyOutcomeTypes.StillBirth),
      },
      {
        Ref: PregnancyOutcomeTypes.AbortionInduced,
        Name: DomainEnums.PregnancyOutcomeTypesName(PregnancyOutcomeTypes.AbortionInduced),
      },
      {
        Ref: PregnancyOutcomeTypes.Miscarriage,
        Name: DomainEnums.PregnancyOutcomeTypesName(PregnancyOutcomeTypes.Miscarriage),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static PregnancyOutcomeTypesNames(item: PregnancyOutcomeTypes) {
    switch (item) {
      case PregnancyOutcomeTypes.LiveBirth:
        return "ENUMS.PREGNANCY_OUTCOME_TYPES.LiveBirth";
      case PregnancyOutcomeTypes.StillBirth:
        return "ENUMS.PREGNANCY_OUTCOME_TYPES.StillBirth";
      case PregnancyOutcomeTypes.AbortionInduced:
        return "ENUMS.PREGNANCY_OUTCOME_TYPES.AbortionInduced";
      case PregnancyOutcomeTypes.Miscarriage:
        return "ENUMS.PREGNANCY_OUTCOME_TYPES.Miscarriage";
      default:
        return "";
    }
  }

  public static PregnancyOutcomeTypesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: PregnancyOutcomeTypes.LiveBirth,
        Name: DomainEnums.PregnancyOutcomeTypesNames(PregnancyOutcomeTypes.LiveBirth),
      },
      {
        Ref: PregnancyOutcomeTypes.StillBirth,
        Name: DomainEnums.PregnancyOutcomeTypesNames(PregnancyOutcomeTypes.StillBirth),
      },
      {
        Ref: PregnancyOutcomeTypes.AbortionInduced,
        Name: DomainEnums.PregnancyOutcomeTypesNames(PregnancyOutcomeTypes.AbortionInduced),
      },
      {
        Ref: PregnancyOutcomeTypes.Miscarriage,
        Name: DomainEnums.PregnancyOutcomeTypesNames(PregnancyOutcomeTypes.Miscarriage),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // OutcomePlaceTypes ==========================================
  public static OutcomePlaceTypesName(item: OutcomePlaceTypes) {
    switch (item) {
      case OutcomePlaceTypes.Home:
        return "Home";
      case OutcomePlaceTypes.Hospital:
        return "Hospital";
      default:
        return "";
    }
  }

  public static OutcomePlaceTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: OutcomePlaceTypes.Home,
        Name: DomainEnums.OutcomePlaceTypesName(OutcomePlaceTypes.Home),
      },
      {
        Ref: OutcomePlaceTypes.Hospital,
        Name: DomainEnums.OutcomePlaceTypesName(OutcomePlaceTypes.Hospital),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static OutcomePlaceTypesNames(item: OutcomePlaceTypes) {
    switch (item) {
      case OutcomePlaceTypes.Home:
        return "ENUMS.OUTCOME_PLACE_TYPES.Home";
      case OutcomePlaceTypes.Hospital:
        return "ENUMS.OUTCOME_PLACE_TYPES.Hospital";
      default:
        return "";
    }
  }

  public static OutcomePlaceTypesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: OutcomePlaceTypes.Home,
        Name: DomainEnums.OutcomePlaceTypesNames(OutcomePlaceTypes.Home),
      },
      {
        Ref: OutcomePlaceTypes.Hospital,
        Name: DomainEnums.OutcomePlaceTypesNames(OutcomePlaceTypes.Hospital),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }


  


  // ============= Sterilisation Types bi-lingual  ===============
  
  public static SterilisationTypeNameLang(
    SterilisationType: SterilisationTypeslang,
  ) {
    switch (SterilisationType) {
      case SterilisationTypeslang.TubalLigation:
        return "ENUMS.STERILISATION.TubalLigation";
      case SterilisationTypeslang.Vasectomy:
        return "ENUMS.STERILISATION.Vasectomy";
      default:
        return "";
    }
  }

  public static SterilisationTypeListlang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: SterilisationTypeslang.TubalLigation,
        Name: DomainEnums.SterilisationTypeNameLang(
          SterilisationTypeslang.TubalLigation,
        ),
      },
      {
        Ref: SterilisationTypeslang.Vasectomy,
        Name: DomainEnums.SterilisationTypeNameLang(
          SterilisationTypeslang.Vasectomy,
        ),
      },
  
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }



  
  // ============= UPT Test Result Types bi-lingual  ===============

  public static UPTTestResultTypeNameLang(
    UPTTestResultTypes: UPTTestResultType,
  ) {
    switch (UPTTestResultTypes) {
      case UPTTestResultType.Positive:
        return "ENUMS.UPT_TEST_RESULT.Positive";
      case UPTTestResultType.Negative:
        return "ENUMS.UPT_TEST_RESULT.Negative";
      default:
        return "";
    }
  }

  public static UPTTestResultTypeListlang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: UPTTestResultType.Positive,
        Name: DomainEnums.UPTTestResultTypeNameLang(
          UPTTestResultType.Positive,
        ),
      },
      {
        Ref: UPTTestResultType.Negative,
        Name: DomainEnums.UPTTestResultTypeNameLang(
          UPTTestResultType.Negative,
        ),
      },
  
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

   // Still Birth Type =======================================================

  public static StillBirthTypesName(item: StillBirthTypes) {
    switch (item) {
      case StillBirthTypes.Fresh:
        return "Fresh";
      case StillBirthTypes.Macerated:
        return "Macerated";
      default:
        return "";
    }
  }

  public static StillBirthTypesList(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: StillBirthTypes.Fresh,
        Name: DomainEnums.StillBirthTypesName(StillBirthTypes.Fresh),
      },
      {
        Ref: StillBirthTypes.Macerated,
        Name: DomainEnums.StillBirthTypesName(StillBirthTypes.Macerated),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  public static StillBirthTypesNames(item: StillBirthTypes) {
    switch (item) {
      case StillBirthTypes.Fresh:
        return "ENUMS.STILL_BIRTH_TYPES.Fresh";
      case StillBirthTypes.Macerated:
        return "ENUMS.STILL_BIRTH_TYPES.Macerated";
      default:
        return "";
    }
  }

  public static StillBirthTypesListLang(
    includeAllOption: boolean = false,
    allOptionString: string = "<All>",
  ) {
    let result = [
      {
        Ref: StillBirthTypes.Fresh,
        Name: DomainEnums.StillBirthTypesNames(StillBirthTypes.Fresh),
      },
      {
        Ref: StillBirthTypes.Macerated,
        Name: DomainEnums.StillBirthTypesNames(StillBirthTypes.Macerated),
      },
    ];

    if (includeAllOption) {
      let allOption = { Ref: 0, Name: allOptionString };
      result.unshift(allOption);
    }

    return result;
  }

  // Death Type BI-lingual Enum

  public static DeathTypesName(item: DeathTypes) {
  switch (item) {
    case DeathTypes.Natural:
      return "Natural";
    case DeathTypes.Accidental:
      return "Accidental";
    case DeathTypes.Suicide:
      return "Suicide";
    case DeathTypes.Homicide:
      return "Homicide";
    case DeathTypes.Sick:
      return "Due to Illness";
    default:
      return "";
  }
}

public static DeathTypesList(
  includeAllOption: boolean = false,
  allOptionString: string = "<All>",
) {
  let result = [
    {
      Ref: DeathTypes.Natural,
      Name: DomainEnums.DeathTypesName(DeathTypes.Natural),
    },
    {
      Ref: DeathTypes.Accidental,
      Name: DomainEnums.DeathTypesName(DeathTypes.Accidental),
    },
    {
      Ref: DeathTypes.Suicide,
      Name: DomainEnums.DeathTypesName(DeathTypes.Suicide),
    },
    {
      Ref: DeathTypes.Homicide,
      Name: DomainEnums.DeathTypesName(DeathTypes.Homicide),
    },
    {
      Ref: DeathTypes.Sick,
      Name: DomainEnums.DeathTypesName(DeathTypes.Sick),
    },
  ];

  if (includeAllOption) {
    let allOption = { Ref: 0, Name: allOptionString };
    result.unshift(allOption);
  }

  return result;
}

public static DeathTypesNames(item: DeathTypes) {
  switch (item) {
    case DeathTypes.Natural:
      return "ENUMS.DEATH_TYPES.Natural";
    case DeathTypes.Accidental:
      return "ENUMS.DEATH_TYPES.Accidental";
    case DeathTypes.Suicide:
      return "ENUMS.DEATH_TYPES.Suicide";
    case DeathTypes.Homicide:
      return "ENUMS.DEATH_TYPES.Homicide";
    case DeathTypes.Sick:
      return "ENUMS.DEATH_TYPES.Sick";
    default:
      return "";
  }
}

public static DeathTypesListLang(
  includeAllOption: boolean = false,
  allOptionString: string = "<All>",
) {
  let result = [
    {
      Ref: DeathTypes.Natural,
      Name: DomainEnums.DeathTypesNames(DeathTypes.Natural),
    },
    {
      Ref: DeathTypes.Accidental,
      Name: DomainEnums.DeathTypesNames(DeathTypes.Accidental),
    },
    {
      Ref: DeathTypes.Suicide,
      Name: DomainEnums.DeathTypesNames(DeathTypes.Suicide),
    },
    {
      Ref: DeathTypes.Homicide,
      Name: DomainEnums.DeathTypesNames(DeathTypes.Homicide),
    },
    {
      Ref: DeathTypes.Sick,
      Name: DomainEnums.DeathTypesNames(DeathTypes.Sick),
    },
  ];

  if (includeAllOption) {
    let allOption = { Ref: 0, Name: allOptionString };
    result.unshift(allOption);
  }

  return result;
}
}
